// apiエラー以外のエラーや不明なapiエラー発生時に表示されるコンポーネント
import type React from 'react';

import { ErrorPageHeader } from '@/components/ErrorPageHeader';
import { INQUIRY_URL } from '@/constant';
import { Button } from '@/routes/_embaUserLayout/-components/Button';
import SakiError from './assets/saki_error.png';
import styles from './index.module.scss';

type ErrorFallbackProps = {
  type: 'not_found' | 'maintenance' | 'normal';
  message?: string;
};

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ type, message }) => {
  const isNotFoundError = type === 'not_found';

  const headingText = (() => {
    switch (type) {
      case 'not_found':
        return 'お探しのページが見つかりません';
      case 'maintenance':
        return 'ただいまメンテナンス中です';
      case 'normal':
        return 'エラーが発生しました';
      default:
        return 'エラーが発生しました';
    }
  })();

  return (
    <div className={styles.errorPage}>
      <ErrorPageHeader />
      <div className={styles.errorPageContent}>
        <h2>{headingText}</h2>
        {message && (
          <div className={styles.errorMessage}>
            <p>{message}</p>
          </div>
        )}
        <img className={styles.errorImage} src={SakiError} alt="" />

        <div className={styles.buttonArea}>
          {isNotFoundError ? (
            <a href="/">
              <Button elementType="span">TOPに戻る</Button>
            </a>
          ) : (
            <a href={INQUIRY_URL} target="_blank" rel="noreferrer">
              <Button elementType="span">ヘルプページを見る</Button>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
